import { useContext } from 'react';

import { TagsSelectContext } from '../../components/tags-select/tags-select.context';
import { TagsSelectContextType } from '../types/stateful-list.types';

export function useTagsSelect() {
  const ctx = useContext(TagsSelectContext);
  if (!ctx) throw new Error('useTagsSelect must be used within List.TagsSelect');
  return ctx as TagsSelectContextType;
}
